import { Suspense, useState } from "react";
import { useGlobalSearchParams } from "expo-router";
import { View } from "tamagui";

import { api } from "~/utils/api";
import { Pagination } from "~/components/blocks";
import {
  ResearchFilterprovider,
  ResearchHeader,
  ResearchNavbar,
  ResearchSteps,
  useResearchFilter,
} from "~/components/feature/research";
import type { Slices } from "~/components/feature/research";

const LIMIT = 500;

const Research = () => {
  const { type } = useGlobalSearchParams<{
    type: Slices;
  }>();
  const [page, setPage] = useState(1);
  const { filter } = useResearchFilter();

  const [{ data, totalPages }] = api.research.list.useSuspenseQuery({
    limit: LIMIT,
    offset: LIMIT * (page - 1),
    filter: {
      type,
      ...filter,
    },
  });

  const showPagination = totalPages > 2 && !filter.search;

  return (
    <>
      <View gap={"$5"}>
        {data.map((research, index) => (
          <ResearchSteps key={index} {...research} />
        ))}
      </View>
      {showPagination && (
        <Pagination
          paddingTop={"$7.8"}
          totalPages={totalPages}
          currentPage={page}
          onPageChange={setPage}
        />
      )}
    </>
  );
};

const ResearchPage = () => {
  return (
    <ResearchFilterprovider>
      <ResearchNavbar />
      <ResearchHeader />
      <Suspense>
        <Research />
      </Suspense>
    </ResearchFilterprovider>
  );
};

export default ResearchPage;
